// Tipos e constantes compartilhados entre as sub-abas de Atendimento (CRM WhatsApp)

export type ConversationAgentId =
  | 'orchestrator' | 'capilar' | 'unhas' | 'estetica' | 'terapias'
  | 'gestao' | 'pagamento' | 'pos-venda';

export const AGENT_LABELS: Record<ConversationAgentId, string> = {
  orchestrator: 'Orquestrador',
  capilar: 'Área Capilar',
  unhas: 'Área de Unhas',
  estetica: 'Estética',
  terapias: 'Terapias',
  gestao: 'Gestão e Arte',
  pagamento: 'Pagamento',
  'pos-venda': 'Pós-venda',
};

export const NICHO_AGENTS: ConversationAgentId[] = ['capilar', 'unhas', 'estetica', 'terapias', 'gestao'];

export type FunnelStage = 'Contato' | 'Em Análise' | 'Aprovado' | 'Pagamento Enviado' | 'Pago' | 'Ativo';

export const FUNNEL_STAGES: FunnelStage[] = [
  'Contato', 'Em Análise', 'Aprovado', 'Pagamento Enviado', 'Pago', 'Ativo',
];

export interface LeadRow {
  affiliateId: string;
  schoolName: string;
  responsibleName: string | null;
  whatsapp: string | null;
  state: string | null;
  status: string;
  funnelStage: FunnelStage;
  currentAgent: ConversationAgentId | null;
  conversationStatus: string | null;
  createdAt: string;
}

export type LlmProviderName = 'groq' | 'openai' | 'glm';

export interface AgentEditableConfig {
  agentId: ConversationAgentId;
  nomeAgente: string;
  tom: 'formal' | 'descontraido';
  saudacaoCustom?: string;
  fraseEncerramentoCustom?: string;
  llmProvider?: LlmProviderName;
  respondWithVoice?: boolean;
}

export const ALL_AGENT_IDS: ConversationAgentId[] = [
  'orchestrator', 'capilar', 'unhas', 'estetica', 'terapias', 'gestao', 'pagamento', 'pos-venda',
];

export function formatDateTime(iso: string | null): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('pt-BR');
}
